export const routes = {
  root: '/',

  // Auth
  welcome: '/welcome',
  login: '/login',
  register: '/register',
  reset_password: '/reset-password',
  changePassword: '/change-password',
  forgot_password: {
    root: '/forgot-password',
    reset: '/forgot-password/:token',
  },

  // Admin
  admin: {
    root: '/admin',
    users: {
      root: '/admin/users',
      detail: '/admin/users/:routeId',
      r_root: '/users',
      r_detail: '/users/:routeId',
    },
    routes: {
      root: '/admin/routes',
      create: '/admin/routes/create',
      edit: '/admin/routes/:routeId/edit',
      detail: '/admin/routes/:routeId',
      reorder: '/admin/routes/reorder',
      r_root: '/routes',
      r_create: '/routes/create',
      r_edit: '/routes/:routeId/edit',
      r_detail: '/routes/:routeId',
      r_reorder: '/routes/reorder',
      contents: {
        root: '/admin/routes/:routeId/contents',
        detail: '/admin/routes/:routeId/contents/:contentId',
        r_root: '/routes/:routeId/contents',
        r_detail: '/routes/:routeId/contents/:contentId',
      },
      stages: {
        root: '/admin/routes/:routeId/stages',
        detail: '/admin/routes/:routeId/stages/:stageId',
        r_root: '/routes/:routeId/stages',
        r_detail: '/routes/:routeId/stages/:stageId',
        contents: {
          root: '/admin/routes/:routeId/stages/:stageId/contents',
          detail: '/admin/routes/:routeId/stages/:stageId/contents/:contentId',
          r_root: '/routes/:routeId/stages/:stageId/contents',
          r_detail: '/routes/:routeId/stages/:stageId/contents/:contentId',
        },
      },
    },
    content: {
      root: '/admin/content',
      create: '/admin/content/create',
      edit: '/admin/content/:contentId',
      r_root: '/content',
      r_create: '/content/create',
      r_edit: '/content/:contentId',
    },
  },

  // App
  calendar: '/calendar',
  profile: '/profile',
  routes: {
    root: '/routes',
    detail: '/routes/:routeId',
    r_detail: '/:routeId',
    content: {
      detail: '/routes/:routeId/content/:contentId',
      complete: '/routes/:routeId/content/:contentId/complete',
      r_detail: '/:routeId/content/:contentId',
      r_complete: '/:routeId/content/:contentId/complete',
    },
  },
  records: {
    root: '/records',
    daily: {
      tips: '/records/daily-tips',
      intro: '/records/daily-intro',
      reason: '/records/daily-reason',
      finish: '/records/daily-finish',
      emotion: '/records/daily-emotion',
      r_tips: '/daily-tips',
      r_intro: '/daily-intro',
      r_reason: '/daily-reason',
      r_finish: '/daily-finish',
      r_emotion: '/daily-emotion',
    },
  },
};
